import './TwoColumnLayout.scss';

type TwoColumnLayoutProps = {
  children: React.JSX.Element;
  rightColumn: React.JSX.Element;
  gap?: boolean;
};

function TwoColumnLayout({
  children,
  rightColumn,
  gap,
}: TwoColumnLayoutProps): React.JSX.Element {
  return (
    <div className={'two-column'}>
      <div className={'two-column__left'}>{children}</div>
      <div className={`two-column__right ${gap ? '-gap' : ''}`}>
        {rightColumn}
      </div>
    </div>
  );
}

export default TwoColumnLayout;
